import { render, staticRenderFns } from "./AutoRecommend.vue?vue&type=template&id=6478671d&"
import script from "./AutoRecommend.vue?vue&type=script&lang=js&"
export * from "./AutoRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports